(ns fx.ajax
  (:require [ajax.core :as ax]
            [frontend.logging :as logging]
            [re-frame.core :as rf]))

;; -- helpers ---------------------------------------------------------------

(defn- ->seq [x]
  (if (sequential? x) x [x]))

(defn- dispatch! [target & payload]
  (when target
    (cond
      (vector? target)
      (rf/dispatch (into (vec target) payload))

      (fn? target)
      (apply target payload)

      :else
      (js/console.error "fx.ajax :: invalid dispatch target (must be event vector or fn):" (type target) target))))

(defn- transit-format []
  {:request  (ax/transit-request-format)
   :response (ax/transit-response-format)})

(defn- json-format []
  {:request  (ax/json-request-format)
   :response (ax/json-response-format {:keywords? true})})

(defn- pick-formats [format]
  #_(js/console.log "PICK FORMATS : " format)
  (case format
    :json (json-format)
    ;; default Transit
    (transit-format)))

(defn- classify-reply
  "Normalize cljs-ajax low-level replies to {:ok? true :data ...} or {:ok? false :error ...}."
  [reply]
  (if (and (vector? reply) (= 2 (count reply)))
    (let [[ok? payload] reply]
      (if ok?
        {:ok? true :data payload}
        {:ok? false :error payload}))
    {:ok? true :data reply}))

(defn valid-args?
  [{:keys [operation on-ok on-error]}]
  (cond (not (keyword? operation))
        (do
          (js/console.error "fx.ajax :: :operation must be a keyword" (type operation) operation)
          (dispatch! on-error {:error   :fx.ajax/invalid-operation
                               :message "fx.ajax :: :operation must be a keyword"
                               :value   operation})
          false)

        (not (and on-ok on-error))
        (do (js/console.error "fx.ajax :: must have :on-ok and :on-error handlers" {:on-ok on-ok :on-error on-error})
            (dispatch! on-error {:error   :fx.ajax/missing-handlers
                                 :message "fx.ajax :: must have :on-ok and :on-error handlers"})
            false)

        (not (or (fn? on-ok) (vector? on-ok)))
        (do
          (js/console.error "fx.ajax ::send 'on-ok:' must be an event vector or a fn" (type on-ok) on-ok)
          (dispatch! on-error {:error   :fx.ajax/invalid-dispatch-target
                               :which   :on-ok
                               :message "fx.ajax ::send 'on-ok' must be an event vector or a fn"
                               :value   on-ok})
          false)
        (not (or (fn? on-error) (vector? on-error)))
        (do
          (js/console.error "fx.ajax ::send 'on-ok:' must be an event vector or a fn" (type on-error) on-error)
          false)
        :else
        true))

;; -- effect: ::ajax/send ---------------------------------------------------
;; Usage:
;; (rf/dispatch [::rpc
;;               {:operation :zap-vault/save-changes!
;;                :body      changes
;;                :format    :json ;; or omit for Transit (default)
;;                :headers   {"Content-Type" "application/transit+json"  ;; or "application/json"
;;                             "Accept"       "application/transit+json"}
;;                :on-request [:loading/show]
;;                :on-ok      [:zap/save-ok]
;;                :on-error   [:notify/error]
;;                :timeout-ms 15000
;;                :transform-reply identity}])

(rf/reg-fx
 ::send
 (fn send-effect [reqs]
   (doseq [{:keys [operation body headers format on-ok on-error timeout-ms transform-reply uri]
            :or   {timeout-ms 60000
                   format     :edn
                   uri        "/rpc"}
            :as   req} (->seq reqs)]

     #_(js/console.log "AJAX FX : " operation " << " (keyword? operation))

     (let [valid? (valid-args? req)]
       #_(js/console.log "AJAX FX Valid? : " valid?)
        ;; runtime guards (avoid `assert` in prod builds)
       (if-not valid?
         (logging/error "Invalid AJAX FX args " req)
         (let [formats (pick-formats format)
                ;; We'll re-dispatch to caller handlers, preserving their API
               response-wrapper (fn [reply]
                                  (let [{:keys [ok? data error]} (classify-reply reply)
                                        data (cond-> data
                                               (and ok? transform-reply) (transform-reply))]
                                    (if ok?
                                      (dispatch! on-ok data)
                                      (dispatch! on-error error))))
               error-wrapper (fn [error]
                               (dispatch! on-error error))
                ;; Tell server which serialization we are using (Transit or JSON)
               hdrs (let [ctype (if (= format :json)
                                  "application/json"
                                  "application/transit+json")
                          accept ctype]
                      (merge {"Content-Type" ctype
                              "Accept"       accept}
                             headers))
               params {:operation operation :body body}]
           #_(js/console.log "Send ajax : " params " << " formats)
            ;; delegate to http-fx
            ;; issue the request via cljs-ajax and re-dispatch to our wrappers
           (ax/ajax-request
            {:method          :post
             :uri             uri
             :headers         hdrs
             :params          params
             :timeout         timeout-ms
             :format          (:request formats)
             :response-format (:response formats)
             :handler         response-wrapper
             :error-handler   error-wrapper})))))))
